import React from "react";

// nav bar

// state

const TemplePillars = () => {
  return <div>TemplePillars</div>;
};

export default TemplePillars;
